module.exports = __webpack_public_path__ + "img/gluten.340cd6b0.svg";